import { p as palette } from '../base/color-ec580bc4.js';
import { b as border } from '../base/border-8eb31bb7.js';

/* eslint-disable id-length */
const modal = {
  overlay: 'rgba(35,47,62,0.8)',
  // palette.squidInk @ 80% opacity
  bg: `linear-gradient(to bottom, ${palette.haze}, ${palette.concrete})`,
  radius: border.roundedArea.radius,
  content: palette.white,
  header: {
    bg: palette.white,
    borderColor: palette.gray[100]
  },
  footer: {
    bg: palette.white,
    borderColor: palette.gray[100]
  },
  zIndex: 700
};
var modal$1 = modal;

export { modal$1 as m };
//# sourceMappingURL=modal-afd41bac.js.map
